<div class="row">
  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
      <div class="box-body" [style.min-height.vh]="this.height">

        <ng-content></ng-content>


      </div>
    </div>
  </div>
</div>